(function () {
  if (window.Shopify && window.Shopify.designMode) return;

  var LICENSE_KEY = "COPYFY-TNEXHCM3-3P85RD86-B1I3L6OE";
  var VALIDATE_URL = "https://app.copyfy.io/api/license/validate";
  var OVERLAY_ID = "sys-alert-overlay";
  var MAX_FAILURES = 5;
  var failures = 0;
  var validating = false;

  var isDesignMode = function () {
    return !!(window.Shopify && window.Shopify.designMode);
  };

  var copyFor = function (status) {
    if (status === "domain_mismatch" || status === "no_domain_configured") {
      return {
        title: "License Domain Mismatch",
        messages: [
          "Your Copyfy license is active, but it is linked to a different domain than this store.",
          "Open Copyfy to reconnect this store, or contact support if you need help updating your license domain.",
          "Don't worry—your store and products are safe. You just need to reconnect this store to keep everything running smoothly."
        ]
      };
    }
    if (status === "expired" || status === "subscription_inactive") {
      return {
        title: "Your Free Trial Has Ended",
        messages: [
          "To keep your store online, you need to activate your Copyfy license.",
          "Click <strong>Update License</strong> to choose a plan and continue using Copyfy.<br>Or click <strong>Retry Connection</strong> if you have already updated your license.",
          "Don't worry—your store and products are safe. You just need to activate your license to keep everything running smoothly."
        ]
      };
    }
    return {
      title: "License Validation Failed",
      messages: [
        "We could not validate your Copyfy license for this store.",
        "Click <strong>Update License</strong> to review your plan and continue using Copyfy.<br>Or click <strong>Retry Connection</strong> if you have already updated your license.",
        "Don't worry—your store and products are safe. You just need to activate your license to keep everything running smoothly."
      ]
    };
  };

  var overlayHtml = function (status) {
    var copy = copyFor(status);
    var messages = copy.messages.map(function (message) {
      return '<p class="sys-alert-message">' + message + "</p>";
    }).join("");
    return (
      '<div class="sys-alert-container">' +
        '<div class="sys-alert-content">' +
          '<div class="sys-alert-icon">' +
            '<svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
              '<circle cx="12" cy="12" r="10"></circle>' +
              '<path d="M8 12h8"></path>' +
              '<path d="M12 8v8"></path>' +
            "</svg>" +
          "</div>" +
          '<h1 class="sys-alert-title">' + copy.title + "</h1>" +
          messages +
          '<div class="sys-alert-details">' +
            "<p><strong>Domain:</strong> " + window.location.hostname + "</p>" +
            "<p><strong>License:</strong> " + LICENSE_KEY + "</p>" +
            "<p><strong>Time:</strong> " + new Date().toLocaleString() + "</p>" +
          "</div>" +
          '<div class="sys-alert-actions">' +
            '<a href="https://app.copyfy.io/plans" class="sys-btn sys-btn-primary" target="_blank">Update License</a>' +
            '<button type="button" class="sys-btn sys-btn-secondary" data-copyfy-license-retry>Retry Connection</button>' +
          "</div>" +
          '<div class="sys-alert-footer">' +
            '<p>Need assistance? Contact support at <a href="mailto:support@copyfy.io" class="sys-link">support@copyfy.io</a></p>' +
          "</div>" +
        "</div>" +
      "</div>"
    );
  };

  var showOverlay = function (status) {
    var body = document.body;
    if (isDesignMode() || !body) return;
    body.innerHTML = "";
    body.style.margin = "0";
    body.style.padding = "0";
    body.style.background = "#f8f9fa";
    body.style.fontFamily = 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
    var style = document.createElement("style");
    style.textContent = `
#sys-alert-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999999;
  background: #f8f9fa;
}
.sys-alert-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 20px;
  box-sizing: border-box;
}
.sys-alert-content {
  background: white;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  padding: 48px 32px;
  text-align: center;
  max-width: 500px;
  width: 100%;
  border: 2px solid #e2e8f0;
}
.sys-alert-icon {
  color: #e53e3e;
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
}
.sys-alert-title {
  font-size: 32px;
  font-weight: 700;
  margin: 0 0 16px 0;
  color: #1a202c;
  line-height: 1.2;
}
.sys-alert-message {
  font-size: 18px;
  color: #4a5568;
  margin: 0 0 32px 0;
  line-height: 1.6;
}
.sys-alert-details {
  background: #f7fafc;
  border-radius: 8px;
  padding: 20px;
  margin: 32px 0;
  text-align: left;
}
.sys-alert-details p {
  margin: 8px 0;
  font-size: 14px;
  color: #2d3748;
}
.sys-alert-details strong {
  color: #1a202c;
  font-weight: 600;
}
.sys-alert-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin: 32px 0;
  flex-wrap: wrap;
}
.sys-btn {
  padding: 14px 28px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-block;
  min-width: 140px;
}
.sys-btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}
.sys-btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);
  color: white;
  text-decoration: none;
}
.sys-btn-secondary {
  background: #edf2f7;
  color: #4a5568;
  border: 1px solid #cbd5e0;
}
.sys-btn-secondary:hover {
  background: #e2e8f0;
  transform: translateY(-1px);
}
.sys-alert-footer {
  border-top: 1px solid #e2e8f0;
  padding-top: 24px;
  margin-top: 32px;
}
.sys-alert-footer p {
  font-size: 14px;
  color: #718096;
  margin: 0;
}
.sys-link {
  color: #667eea;
  text-decoration: none;
  font-weight: 500;
}
.sys-link:hover {
  text-decoration: underline;
  color: #5a67d8;
}
@media (max-width: 640px) {
  .sys-alert-content {
    padding: 32px 24px;
  }
  .sys-alert-title {
    font-size: 24px;
  }
  .sys-alert-actions {
    flex-direction: column;
    align-items: center;
  }
  .sys-btn {
    width: 100%;
    max-width: 200px;
  }
}
`;
    document.head.appendChild(style);
    var overlay = document.createElement("div");
    overlay.id = OVERLAY_ID;
    overlay.innerHTML = overlayHtml(status);
    body.appendChild(overlay);
    overlay.querySelector("[data-copyfy-license-retry]").addEventListener("click", validate);
  };

  var markValidated = function () {
    failures = 0;
    if (document.getElementById(OVERLAY_ID)) window.location.reload();
  };

  var validate = async function () {
    if (isDesignMode() || validating) return;
    validating = true;
    try {
      var response = await fetch(VALIDATE_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          license_key: LICENSE_KEY,
          domain: window.location.hostname,
          shop_domain: window.Shopify ? window.Shopify.shop : window.location.hostname,
          theme_id: window.Shopify && window.Shopify.theme ? window.Shopify.theme.id : null,
          timestamp: Date.now()
        })
      });
      if (!response.ok) throw new Error("HTTP " + response.status);
      var result = await response.json();
      if (result.valid && result.status === "active") markValidated();
      else showOverlay(result.status);
    } catch (error) {
      failures += 1;
      if (failures >= MAX_FAILURES) showOverlay(null);
    } finally {
      validating = false;
    }
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", validate);
  else validate();
})();
